export default __webpack_public_path__ + "/images/graduation_cap.png";